import { Component, OnInit, Inject } from '@angular/core';
import { ContentService } from 'src/app/content.service';
import { markupReport, printReport } from '../../../salg/print-stuff';
import { MDC_DIALOG_DATA, MdcDialogRef } from '@angular-mdc/web';
@Component({
  selector: 'app-zrapport',
  templateUrl: './xzrapport.component.html',
  styleUrls: ['./xzrapport.component.scss']
})
export class XzrapportComponent implements OnInit {

  constructor(
    @Inject(MDC_DIALOG_DATA) private data,
    private dialogRef: MdcDialogRef<XzrapportComponent>,
    private contentService: ContentService
  ) {}

  public rapportData: any;
  public rapportHTML: string = 'Henter rapport-data...';
  public payload = {};

  ngOnInit() {

    if (this.data.type === 'z') {
      this.payload = {
        'belop_opptalt': this.data.belop_opptalt,
        'diff_kommentar': this.data.diff_kommentar,
        'fribillett_utdelt': this.data.fribillett_utdelt,
        'fribillett_begrunnelse': this.data.fribillett_begrunnelse,
        'checklist_data': {
          'sjekkliste': this.data.sjekkliste,
          'kommentar': this.data.sjekkliste_kommentar
        }
      }
    }

    this.contentService.postContent(`/salg/${this.data.type}rapport`, this.payload)
      .subscribe(rData => {
        this.rapportData = rData;
        this.rapportHTML = markupReport(rData);
      });
  }

  print() {
    printReport(this.rapportData);
    this.dialogRef.close();
  }

}
